import React from 'react';
import PropTypes from 'prop-types';

import { getLangValue } from '../../../utils/Generic';
import { getOccupancyLabel } from '../../../utils/Room';

import DsBookingSummary from '../../ds/organism/BookingSummary';
import { BookingDistribution } from '../../../utils/distribution';
import DsImage from '../../ds/atoms/image/Image';

const RoomInfo = ({ cartRoom, lang, context }) => {
  const hasRoomPhoto = cartRoom.room.photos.length > 0;
  return (
  <div className="flex">
    {hasRoomPhoto && <figure className="w-1/3">
      <DsImage img={cartRoom.room.photos[0].url}
      width={500} height={250} alt="hotel"
      className="min-h-full object-cover"/>
      </figure> }
     <div className="w-2/3 px-3 pb-2">
        <div className="rtext-primary text-sm font-bold">
          {getLangValue(cartRoom.room, lang, 'name')}
        </div>
        <div className="text-gray-500 text-xs mb-2">
          {getOccupancyLabel(cartRoom.use, context)}
        </div>
      <div className="text-primary text-xxs my-1 uppercase font-bold">
        {getLangValue(cartRoom.board, lang, 'name')}
      </div>
      <div className="text-primary text-xxs my-1 uppercase font-bold">
        {getLangValue(cartRoom.rate, lang, 'name')}
      </div>
    </div>
  </div>);
};

const HotelShareCart = ({
  hotel, chain, lastRequestedInfo, cartRoom, distribution, lang,
}, context) => {
  const hasRooms = Boolean(cartRoom && cartRoom.room);
  const hasHotelPhotos = hotel && hotel.photos != null;
  const dates = {
    checkIn: lastRequestedInfo.checkin || lastRequestedInfo.check_in,
    checkOut: lastRequestedInfo.checkout || lastRequestedInfo.check_out,
  };
  const getDistribution = distribution && new BookingDistribution(distribution).distribution;
  return (
  <div className="HotelShareCart mt-2">
    <DsImage img={hotel.logo} width={200} height={150} alt="logo" className="w-40 mx-auto my-2 p-2"/>
    <DsBookingSummary
      className="px-2 pb-4"
      hotel={hotel}
      dates={dates}
      distribution={getDistribution}
      lang={lang}
      chain={chain}/>
    {hasRooms && <RoomInfo cartRoom={cartRoom} lang={lang} context={context}/>}
    {!hasRooms && hasHotelPhotos
    && <DsImage img={hotel.photos[0].url} width={500} height={250} alt="hotel"/>
    }
  </div>
  );
};

HotelShareCart.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default HotelShareCart;
